import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import {IRootState} from "../../../../store";
import DispatchProps from "../../../../utils/DispatchProps";
import ApiService from "../../../ApiService";
import Table, {TableColumn} from "../../../Table";
import {CommandBarButton} from "office-ui-fabric-react";
import JsonViewerCard from "../../../JsonViewerCard";
import {DriveItem, Permission} from "@microsoft/microsoft-graph-types";
import SchoolPageTitle from '../../../SchoolPageTitle';
import AdminSchoolMenu from '../../../AdminSchoolMenu';


export interface DriveItemExploreResult
{
    driveItem: DriveItem,
    permissions: Permission[];
}
interface ExploreDriveItemPageProps {
    tenantId: string;
    schoolCode: string;
    driveId: string;
    driveItemId: string;
    apiService: ApiService;
}

interface ExploreDriveItemPageState {
    driveItemExploreResult?: DriveItemExploreResult;
    showJson: boolean;
}

const DRIVE_ITEM_COLUMNS: TableColumn[] = [
    {title: "Id",propertyPath: "id",enableSort: false, flex: 1},
    {title: "Name",propertyPath: "name",enableSort: false, flex: 1},
];

const DRIVE_ITEM_PERMISSIONS_COLUMNS: TableColumn[] = [
    {title: "Id",propertyPath: "id",enableSort: false, flex: 1},
    {title: "Roles",propertyPath: "roles",enableSort: false, flex: 1},
];


class ExploreDriveItemPage extends Component<ExploreDriveItemPageProps & DispatchProps, ExploreDriveItemPageState> {
    static displayName = ExploreDriveItemPage.name;

    constructor(props: ExploreDriveItemPageProps & DispatchProps) {
        super(props);

        this.state = {
            driveItemExploreResult: undefined,
            showJson: false
        }
    }

    async componentDidMount() {
        const driveItemExploreResult = await this.props.apiService.exploreDriveItem(this.props.tenantId,this.props.schoolCode,this.props.driveId,this.props.driveItemId);

        this.setState({
            driveItemExploreResult
        });
    }

    async componentDidUpdate(prevProps: Readonly<ExploreDriveItemPageProps & DispatchProps>, prevState: any): Promise<void> {

    }

    render() {

        const jsonButton = (
            <CommandBarButton
                iconProps={{ iconName: "code" }}
                text={"Show all json"}
                onClick={() => {
                    this.setState({ showJson: true })
                }}
            />
        );

        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Explore Drive Item" />

                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />

                {this.state.showJson ?
                    <JsonViewerCard title={""} jsonObject={this.state.driveItemExploreResult!}>
                        <CommandBarButton
                            iconProps={{ iconName: "cancel" }}
                            text={"Close"}
                            onClick={() => {
                                this.setState({ showJson: false })
                            }}
                        />
                    </JsonViewerCard> : null}

                <Table
                    title={this.state.driveItemExploreResult?.driveItem.id}
                    columns={DRIVE_ITEM_COLUMNS}
                    items={this.state.driveItemExploreResult?.driveItem ? [this.state.driveItemExploreResult.driveItem] : []}>
                    {this.state.showJson ? null : jsonButton}
                </Table>

                
                <Table
                    title={"Permissions"}
                    columns={DRIVE_ITEM_PERMISSIONS_COLUMNS}
                    items={this.state.driveItemExploreResult?.permissions || []}/>

            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: any): ExploreDriveItemPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;
        const driveId = ownProps.match.params.driveId;
        const driveItemId = ownProps.match.params.driveItemId;

        return {
            tenantId: tenantId,
            schoolCode: schoolCode,
            driveId: driveId,
            driveItemId: driveItemId,
            apiService: state.auth.apiService
        };
    }
)(ExploreDriveItemPage)